import { PatientsContentHeader, PatientsTable } from '@features/patients/components';
import { AppLayout } from '@features/ui/components/layout/AppLayout';
import { NextPageWithLayout } from '@features/ui/types/NextPageWithLayout';
import staticProps from '@services/staticProps';
import { ReactElement } from 'react';

const Patients: NextPageWithLayout = () => (
  <>
    <PatientsContentHeader />
    <PatientsTable />
  </>
);

Patients.getLayout = function getLayout(page: ReactElement) {
  return <AppLayout>{page}</AppLayout>;
};

export default Patients;

export const getStaticProps = staticProps;
